import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["display", "form", "input"]
  static values = { 
    gigId: Number,
    touringId: Number
  }

  connect() {
    // Stocker la valeur originale au connect si l'input existe
    if (this.hasInputTarget) {
      this.originalCity = this.inputTarget.value || ""
    } else {
      this.originalCity = ""
    }
    
    // Auto-focus l'input si le formulaire est déjà visible
    if (this.hasFormTarget && !this.formTarget.classList.contains("hidden") && this.hasInputTarget) {
      this.inputTarget.focus()
    }

    // Gérer l'escape key pour annuler
    this.keydownHandler = this.handleKeydown.bind(this)
  }

  startEdit(event) {
    event.preventDefault()
    
    // Vérifier que tous les targets existent
    if (!this.hasDisplayTarget || !this.hasFormTarget || !this.hasInputTarget) {
      return
    }
    
    // Stocker la valeur actuelle comme backup
    this.originalCity = this.inputTarget.value || ""
    
    // Masquer l'affichage et montrer le formulaire
    this.displayTarget.classList.add("hidden")
    this.formTarget.classList.remove("hidden")
    
    // Focus l'input d'autocomplete et sélectionner le texte existant
    setTimeout(() => {
      // Trouver l'input visible créé par l'autocomplete Mapbox
      const geocoderInput = this.formTarget.querySelector('.mapboxgl-ctrl-geocoder input')
      if (geocoderInput) {
        geocoderInput.focus()
        geocoderInput.select()
        
        // Synchroniser les valeurs quand l'utilisateur tape
        geocoderInput.addEventListener('input', (e) => {
          this.inputTarget.value = e.target.value
        })
      } else {
        // Fallback vers l'input target si l'autocomplete n'est pas encore initialisé
        this.inputTarget.focus()
        this.inputTarget.select()
      }
    }, 100) // Augmenter le délai pour laisser le temps à l'autocomplete de s'initialiser

    // Écouter les touches clavier
    document.addEventListener("keydown", this.keydownHandler)
  }

  cancelEdit(event) {
    if (event) event.preventDefault()
    
    // Restaurer l'affichage
    this.formTarget.classList.add("hidden")
    this.displayTarget.classList.remove("hidden")
    
    // Remettre la valeur originale dans le champ caché
    this.inputTarget.value = this.originalCity
    
    // Remettre aussi la valeur originale dans l'autocomplete
    const geocoderInput = this.formTarget.querySelector('.mapboxgl-ctrl-geocoder input')
    if (geocoderInput) {
      geocoderInput.value = this.originalCity
    }
    
    // Arrêter d'écouter les touches clavier
    document.removeEventListener("keydown", this.keydownHandler)
  }

  handleKeydown(event) {
    if (event.key === "Escape") {
      this.cancelEdit()
    } else if (event.key === "Enter") {
      // Vérifier si c'est l'input d'autocomplete ou l'input target
      const geocoderInput = this.formTarget.querySelector('.mapboxgl-ctrl-geocoder input')
      if (event.target === this.inputTarget || event.target === geocoderInput) {
        // Laisser le form se soumettre naturellement
        return true
      }
    }
  }

  handleSubmit(event) {
    // Arrêter d'écouter les touches clavier
    document.removeEventListener("keydown", this.keydownHandler)
  }

  disconnect() {
    // Nettoyer les event listeners
    document.removeEventListener("keydown", this.keydownHandler)
  }
}